module.exports = __webpack_public_path__ + "img/icon-onetarget.3638f3f7.png";